import React from 'react';
import Page from "../../containers/Page/Page";
import { Button, Box, Typography, TableContainer, Table, TableHead, TableCell, TableRow, TableBody, Grid } from "@material-ui/core";
import { Pagination } from '@material-ui/lab';
import SearchField from "../../components/SearchField";
import { useHistory } from "react-router-dom";
import { api } from '../../services/api';
import moment from 'moment';
import { formatCurrency } from '../../components/CurrencyInput/helpers/CurrencyHelpers';
import { Helpers } from '../../utils/Helpers';
import { usePermissions } from '../../hooks/permissions';

interface IData {
    data: {
        id: string;
        numcpp: string;
        desc_cpp: string;
        moeda: string;
        valor_unit_cpp: string;
        fat_mg2: string;
        fat_gross: string;
        valido_de: string;
        valido_ate: string;
        created_at: string;
    }[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

function CPP() {

    //Hooks    
    const history = useHistory();
    const permissions = usePermissions();
    const query = new URLSearchParams(history.location.search);

    //States
    const [error, setError] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [search, setSearch] = React.useState<string>(query.get('search') || '');
    const [data, setData] = React.useState<IData>();

    //Effects
    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Carregar CPPs.
     * @param page 
     * @returns void
     */
    async function handleFetch(page: number = Number(query.get('page')) || 1) {
        setLoading(true);
        try {
            const url = `/cpp?search=${search}&page=${page}`;
            const response = await api.get(url);
            history.push(url);
            setData(response.data.object);
            setError('');
        } catch (error: any) {
            setError(Helpers.errorFormat(error));
        }
        setLoading(false);
    }

    /**
     * Pesquisar com ENTER.
     * @param event 
     */
    function handleSearchKeyUp(event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) {
        if (event.key === 'Enter') {
            handleFetch(1);
        }
    }

    return (
        <Page error={error} loading={loading}>
            <Page.Title>
                <Typography variant="h6" component="div">
                    CPP
                </Typography>
                <Box display="flex">
                    {permissions.has('cpp.show') &&
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={() => history.push('/cpp/create')}>
                            Novo CPP
                        </Button>
                    }
                </Box>
            </Page.Title>
            {data &&
                <Page.Section>
                    <Page.Toolbar>
                        <SearchField
                            placeholder="Pesquisa"
                            value={search}
                            onChange={(event) => setSearch(event.target.value)}
                            onKeyUp={(event) => handleSearchKeyUp(event)}
                            onClick={() => handleFetch(1)}
                        />
                    </Page.Toolbar>
                    <Page.Content>
                        <TableContainer>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell>Num. CPP</TableCell>
                                        <TableCell>Desc. CPP</TableCell>
                                        <TableCell>Moeda</TableCell>
                                        <TableCell>Valor Unit. CPP</TableCell>
                                        <TableCell>Fat. MG2</TableCell>
                                        <TableCell>Fat. Gross</TableCell>
                                        <TableCell>Valido De</TableCell>
                                        <TableCell>Valido Até</TableCell>
                                        <TableCell>Data Criação</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.data.map((cpp) => (
                                        <TableRow
                                            key={cpp.id}
                                            hover={true}
                                            onClick={() => history.push(`/cpp/${cpp.id}`)}
                                        >
                                            <TableCell>{cpp.id}</TableCell>
                                            <TableCell>{cpp.numcpp}</TableCell>
                                            <TableCell>{cpp.desc_cpp}</TableCell>
                                            <TableCell>{cpp.moeda}</TableCell>
                                            <TableCell>{cpp.valor_unit_cpp ? formatCurrency('pt-BR', parseFloat(cpp.valor_unit_cpp), 'BRL', true) : ''}</TableCell>
                                            <TableCell>{cpp.fat_mg2}</TableCell>
                                            <TableCell>{cpp.fat_gross}</TableCell>
                                            <TableCell>{cpp.valido_de ? moment(cpp.valido_de).format('DD/MM/YYYY') : ''}</TableCell>
                                            <TableCell>{cpp.valido_ate ? moment(cpp.valido_ate).format('DD/MM/YYYY') : ''}</TableCell>
                                            <TableCell>{cpp.created_at ? moment(cpp.created_at).format('DD/MM/YYYY') : ''}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box p={2}>
                            <Grid container justifyContent="center">
                                <Pagination
                                    page={data.current_page}
                                    count={data.last_page}
                                    onChange={(_event, page) => handleFetch(page)}
                                    color="secondary"
                                />
                            </Grid>
                        </Box>
                    </Page.Content>
                </Page.Section>
            }
        </Page >
    );
}

export default CPP;